import React from 'react';
import { FaTrophy, FaLayerGroup, FaProjectDiagram } from 'react-icons/fa';
import { GroupForm, TeamForm, MatchForm, GroupTable, ClassifiedTeams, SectionCard } from '../components';
import './Home.css';

const Home = ({
  groups,
  groupNames,
  classifiedTeams,
  canGenerateKnockout,
  addGroup,
  addTeam,
  addMatch,
  createKnockoutPhase,
}) => (
  <div className="home-page">
    <SectionCard
      className="home-page__section"
      title="Configuración"
      icon={<FaLayerGroup />}
      description="Crea grupos y registra equipos de forma ordenada."
    >
      <GroupForm onAddGroup={addGroup} />
      {groupNames.length > 0 && <TeamForm groupNames={groupNames} onAddTeam={addTeam} />}
    </SectionCard>

    <SectionCard
      className="home-page__section"
      title="Partidos de grupos"
      icon={<FaProjectDiagram />}
      description="Carga resultados para actualizar automáticamente la tabla."
    >
      <MatchForm onAddMatch={addMatch} groups={groups} />
      {groups.map((group) => (
        <GroupTable key={group.name} group={group} />
      ))}
    </SectionCard>

    <SectionCard
      className="home-page__section"
      title="Clasificados"
      icon={<FaTrophy />}
      description="Se calculan por puntos y diferencia de gol."
      actions={(
        <button
          type="button"
          className="btn btn--primary"
          onClick={createKnockoutPhase}
          disabled={!canGenerateKnockout}
        >
          Generar eliminatorias
        </button>
      )}
    >
      <ClassifiedTeams classifiedTeams={classifiedTeams} />
    </SectionCard>
  </div>
);

export default Home;
